/* 布局 */
//前台
import Layout from "@views/layout";

const goodslatticedepositRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodslatticedeposit/list",
        name: "GOODSLATTICEDEPOSIT",
        meta: {
            title: "墓区格位续费套餐",
            keepAlive:true
        },
        component: () => import("@views/business/goodslatticedeposit/index.vue"),
    },
        ],
};

export default goodslatticedepositRouter;
